<template>
  <div id="suppliers" class="px-4">
    <shipment-profile-list />
  </div>
</template>
<script>
import ShipmentProfileList from "@/components/shipment_profile_management/ShipmentProfileList.vue";
export default {
  components: {
    ShipmentProfileList
  }
};
</script>
